function ScopeComponent(Component) {
  if (!Component.mounted) {
    Component.mounted = [];
  } else if (!Array.isArray(Component.mounted)) {
    Component.mounted = [Component.mounted];
  }
  Component.mounted.push(function() {
    this.$el.setAttribute("data-v-".concat("488037d"), "");
  });
}
export {
  ScopeComponent as S
};
//# sourceMappingURL=ScopeComponent-DsONbC6w.mjs.map
